import { getRequest } from '../api-handler';
import { PlantDetailDto } from './plant';

export const PlantApi = {
  getById: (id: number) => getRequest<PlantDetailDto>(`/plants/${id}`)
};
